<script>
    import { createForm } from "svelte-forms-lib";
    import { slide, fade } from 'svelte/transition';
    import DateSearcher from "../../SearchBars/DateSearcher.svelte";
    import PrefixSearcher from "../PrefixSearcher.svelte";
    import { imask } from 'svelte-imask';
    import CountrySearcher from "../../SearchBars/CountrySearcher.svelte";
    import CapSearcher from "../../SearchBars/CapSearcher.svelte";
    import CitySearcher from "../../SearchBars/CitySearcher.svelte";
    import GroupNameSearcher from "../../SearchBars/GroupNameSearcher.svelte";
    import { subscribeMultiple } from "../../../services/subscribersService";
    import toast from "svelte-french-toast";
    import { onDestroy } from "svelte";
    import Accordion from "./Accordion.svelte";
    import InputField from "../InputField.svelte";
    import Select from "svelte-select";
    import { getProvinceSelectList, getFilteredComuniList, generateFiscalCode } from "../../../utils/codiceFiscale";
    import { dateToInputString } from "../../../utils/dateToInputString";
    import { formatSubscriber, membershipsValidationSchema, mappedProfessions } from "../../../utils/subscribers";
    import { getOptionalSelectValue } from "../../../utils/getOptionalSelectValue";
    import { settings } from "../../../stores/settingsStore";
    import RadioButtons from "../../SearchBars/RadioButtons.svelte";
    import { findFormError } from "../../../utils/findError";
    import { isUGSActive as isUGSActiveForBirthDate } from "../../../utils/isUGSActive";

    export let token;
    let subErrors = [];
    let isPressed = false;
    let subscriberMaxBirthDate;
    const phoneMask = { mask: '000 000 0000' };

    const genderOptions = (i) => [
        { value: "MALE", label: "Uomo", id: `genderMaleOption${i}` },
        { value: "FEMALE", label: "Donna", id: `genderFemaleOption${i}` },
        { value: "OTHER", label: "Altro", id: `genderOtherOption${i}` },
    ];
    const ugsOptions = (i) => [
        { value: "true", label: "SI", id: `isUGSOption${i}` },
        { value: "false", label: "NO", id: `isNotUGSOption${i}` },
    ];

    const subInfo = {
        subscriber: {
            firstName: "",
            lastName: "",
            birthPlace: "",
            birthProvince: "",
            birthDate: "",
            gender: "MALE",
            email: "",
            nationality: "Italia",
            fiscalCode: "",
            profession: "",
            residenceAddress : {
                code: "",
                street: "",
                number: "",
                secondary: "",
                city: "",
                region: "",
                zip: "",
                province: "",
                country: "Italia",
            },
            phone: {
                code: "+39",
                number:  ""
            },
            isUGS: true
        },
        groupId: "",
        paidAmount: 0,
        isItaly: true,
        zips: [],
    }

    const {
        form,
        handleChange,
        handleSubmit,
        handleReset,
        errors,
    } = createForm({
        initialValues: {
            memberships: [
                { ...subInfo }
            ]
        },
        onSubmit: async (value) => {
            const subscribersMbs = JSON.parse(JSON.stringify(value));

            const invalidAmountIntegerMb = subscribersMbs.memberships.find(m => {
                const num = Number(m.paidAmount.toString().replace(',', '.'));
                return !Number.isFinite(num) || !Number.isInteger(num)
            });

            if (!!invalidAmountIntegerMb) {
                toast.error(`L'iscritto con email '${invalidAmountIntegerMb.subscriber.email}' ha un importo errato, inserisci un numero intero`);
                return;
            }

            const invalidAmountMinPaymentMb = subscribersMbs.memberships.find(m => {
                return +m.paidAmount < (m.subscriber.isUGS === 'true' ? $settings.minimumPaymentUGS : $settings.minimumPaymentNotUGS)
            });

            if (!!invalidAmountMinPaymentMb) {
                toast.error(`L'iscritto con email '${invalidAmountMinPaymentMb.subscriber.email}' ha un importo errato: ` +
                 `inserito ${invalidAmountMinPaymentMb.paidAmount} mentre il minimo è ${(invalidAmountMinPaymentMb.subscriber.isUGS === 'true' ? $settings.minimumPaymentUGS : $settings.minimumPaymentNotUGS)}.`);
                return;
            }

            isPressed = !isPressed;
            const memberships = [...handleSubmitData(subscribersMbs.memberships)];

            await subscribeMultiple(token, memberships).then((resp) => {
                if(!resp.data.errors.length) {
                    toast.success("Gli iscritti sono stati inseriti correttamente");
                    handleReset();

                    return;
                }
                handleErrors(resp.data.errors);
            }).catch((err) => {
                if(err?.response?.status === 500) {
                    toast.error(`Impossibile inserire gli iscritti, errore ${err.toString()}`);
                }
            })

            isPressed = !isPressed;
        },
        validationSchema: membershipsValidationSchema
    });

    function handleSubmitData(memberships) {
        return memberships.map((membership) => ({
            ...membership,
            paidAmount: Number(membership.paidAmount.toString().replace(',', '.')),
            groupId: getOptionalSelectValue(membership?.groupId),
            subscriber: formatSubscriber(membership.subscriber, membership.isUGSActive)
        }));
    }

    const addSubscriber = () => {
        $form.memberships = $form.memberships.concat(JSON.parse(JSON.stringify(subInfo)));

        $errors.memberships = $errors.memberships.concat({
            subscriber: {
                firstName: "",
                lastName: "",
                birthPlace: "",
                birthProvince: "",
                birthDate: "",
                gender: "",
                email: "",
                nationality: "",
                fiscalCode: "",
                profession: "",
                residenceAddress: {
                    street: "",
                    number: "",
                    secondary: "",
                    city: "",
                    region: "",
                    zip: "",
                    province: "",
                    country: ""
                },
                phone: { code: "", number: "" },
                isUGS: ""
            },
            groupId: "",
            isItaly: "",
            paidAmount: "",
            zips: [],
        });
    };

    function removeSubscriber(i) {
        $form.memberships = $form.memberships.filter((_u, j) => j !== i);
        $errors.memberships = $errors.memberships.filter((_e, j) => j !== i);
    }

    function handleStateValue(value, i) {
        $form.memberships[i].isItaly = value.detail.value === "Italia";
        $form.memberships[i].subscriber.residenceAddress.city = "";
        $form.memberships[i].zips = [];
    }

    function handleBirthProvinceChange(i) {
        $errors.memberships[i].subscriber.birthPlace = "Inserisci un valore";
        $errors.memberships[i].subscriber.birthProvince = "";
        $form.memberships[i].subscriber.birthPlace = '';
    }

    function handleBirthPlaceChange(i) {
        $errors.memberships[i].subscriber.birthPlace = "";
    }

    function handleChangeCity(value, i) {
        $form.memberships[i].subscriber.residenceAddress.zip = "";
        $form.memberships[i].zips = value.detail.value.zip.map((e) => {return {value: e, label: e}});
        $form.memberships[i].subscriber.residenceAddress.zip = $form.memberships[i].zips[0];

        $form.memberships[i].subscriber.residenceAddress.code = $form.memberships[i].subscriber.residenceAddress.city.value.code;
        $form.memberships[i].subscriber.residenceAddress.region = $form.memberships[i].subscriber.residenceAddress.city.value.region;
        $form.memberships[i].subscriber.residenceAddress.province = $form.memberships[i].subscriber.residenceAddress.city.value.province;

        $errors.memberships[i].subscriber.residenceAddress = {
            ...$errors.memberships[i].subscriber.residenceAddress,
            city: "",
            region: "",
            zip: "",
            province: "",
            country: "Italia",
        }
    }


    function handleGenerateFiscalCode(i) {
        $form.memberships[i].subscriber.fiscalCode = generateFiscalCode($form.memberships[i].subscriber);
        $errors.memberships[i].subscriber.fiscalCode = "";
    }


    function handleGenderChange(e, i) {
        handleChange(e)
        if (!$form.memberships[i].subscriber.fiscalCode) {
            return;
        }

        if (!isFiscalCodeGeneratorDisabled($form.memberships[i])) {
            handleGenerateFiscalCode(i);
        }
    }

    function translateError(err) {
        switch (true) {
            case err === "Group not found":
                err = "Circolo non trovato";
                break;
            case err.includes("Subscriber is already present for the current subscription active year"):
                err = "L'iscritto associato a questa mail è già iscritto per questo anno";
                break;
            case err.includes("Subscriber is too young"):
                err = "L'iscritto è troppo giovane";
                break;
            case err === "Residence address is not valid.":
                err = "L'indirizzo utilizzato non è corretto";
                break;
            default:
                err = `Dati errati, ${err}`;
                break;

        }

        return err
    }

    function handleErrors(errors) {
        let errorMessage = `Errori sugli iscritti:\n`;

        errors.forEach((err) => {
            errorMessage += `Iscritto ${err.index + 1}: ${translateError(err.message)}`;
        })

        toast.error(errorMessage, { duration: 10000 });
    }

    function filterComuni(label, filterText, option, i) {
        return option.province === $form.memberships[i].subscriber.birthProvince?.value && (!filterText || label.toLowerCase().includes(filterText.toLowerCase()));
    }

    function handleBirthDateChange(i) {
        if ($form.memberships[i].subscriber.birthDate === undefined || !settings) {
            return;
        }

        if (isUGSActive(i)) {
            $form.memberships[i].paidAmount = $settings.minimumPaymentUGS > $form.memberships[i].paidAmount ? $settings.minimumPaymentUGS : $form.memberships[i].paidAmount;
        } else {
            $form.memberships[i].paidAmount = $settings.minimumPaymentNotUGS > $form.memberships[i].paidAmount ? $settings.minimumPaymentNotUGS : $form.memberships[i].paidAmount;
            $form.memberships[i].isUGS  = false;
        }
    }

    const unsubscribeSettings = settings.subscribe((setting) => {
        if (!setting) {
            return;
        }

        const maxDate = new Date();
        maxDate.setFullYear(maxDate.getFullYear() - setting.registrationMinAge);
        subscriberMaxBirthDate = dateToInputString(maxDate);
    });

    onDestroy(unsubscribeSettings);

    $: isFiscalCodeGeneratorDisabled = (form) => !form.subscriber.firstName || !form.subscriber.lastName || !form.subscriber.gender || !form.subscriber.birthDate || !form.subscriber.birthProvince || !form.subscriber.birthPlace;
    $: isUGSActive = (index) =>
        isUGSActiveForBirthDate($form.memberships[index]?.subscriber?.birthDate, $settings?.ugsMaxAgeInclusive);

    $: hasError = (i) => {
        if ($errors.memberships.at(i)) {
            return findFormError($errors.memberships[i]);
        }

        return false;
    }
</script>

<form class="w-full flex-col flex items-center gap-3">

    {#each $form.memberships as _, i}
        <Accordion>
            <div slot="header" class="flex justify-between align-middle items-center h-full w-full py-4">
                <div class="flex justify-between items-center font-450 text-xl h-full w-full {hasError(i) ? 'text-red-400' : ''}">
                    Iscritto #{i+1}
                </div>
                <div id="error{i}" class="font-450 text-red-400">
                    {subErrors[i] ?? ""}
                </div>
                <div>
                    {#if $form.memberships.length !== 1}
                        <button
                            type="button" class="w-52 h-11 text-center bg-red-500 font-450 py-3 text-white hover:shadow-lg transition-all outline-none focus:outline-none"
                            transition:fade on:click|preventDefault={() => removeSubscriber(i)}
                        >
                            Rimuovi iscritto <i class="ml-2 fa fa-minus-circle"></i>
                        </button>
                    {/if}
                </div>
            </div>

            <div slot="content" class="flex flex-col gap-3 justify-between w-full md:px-8 overflow-x-auto h-full px-0.5" transition:slide>
                <!-- Nominativo -->

                <div>
                    <div class="text-lg">Nominativo</div>
                    <div class="w-full flex flex-col gap-3 md:flex-row">
                        <InputField
                            hasLabel={false}
                            placeholder="Nome"
                            bind:value={$form.memberships[i].subscriber.firstName}
                            errorText={$errors.memberships[i]?.subscriber?.firstName}
                            id={`memberships[${i}].subscriber.firstName`}
                            name={`memberships[${i}].subscriber.firstName`}
                            handleChange={handleChange}
                            isRequired={true}
                        />

                        <InputField
                            hasLabel={false}
                            placeholder="Cognome"
                            bind:value={$form.memberships[i].subscriber.lastName}
                            errorText={$errors.memberships[i]?.subscriber?.lastName}
                            name={`memberships[${i}].subscriber.lastName`}
                            handleChange={handleChange}
                            isRequired={true}
                        />
                    </div>
                </div>

                <!-- Luogo di nascita -->
                <div>
                    <div class="text-lg">Luogo di nascita</div>

                    <div class="flex md:flex-row gap-3">
                        <div class="w-full md:w-1/2">
                            <Select
                                items={getProvinceSelectList()}
                                type="text"
                                placeholder="Provincia di nascita"
                                class="select-error-border"
                                name={`memberships[${i}].subscriber.birthProvince`}
                                bind:value={$form.memberships[i].subscriber.birthProvince}
                                on:change={() => handleBirthProvinceChange(i)}
                                hasError={$errors.memberships[i]?.subscriber?.birthProvince}
                                containerStyles="box-shadow: 0px 1px 4px 0px rgb(0 0 0 / 15%); border-radius: 0px; height: 2.75rem"
                            />

                            {#if $errors.memberships[i]?.subscriber?.birthProvince}
                                <div class="pl-3 text-red-500">{$errors.memberships[i]?.subscriber?.birthProvince}</div>
                            {/if}
                        </div>

                        <div class="w-full md:w-1/2">
                            <Select
                                items={getFilteredComuniList()}
                                itemFilter="{(label, filterText, option) => filterComuni(label, filterText, option, i) }"
                                disabled="{!$form.memberships[i].subscriber.birthProvince}"
                                class="select-error-border"
                                type="text"
                                placeholder="Luogo di nascita"
                                name={`memberships[${i}].subscriber.birthPlace`}
                                bind:value={$form.memberships[i].subscriber.birthPlace}
                                on:change={() => handleBirthPlaceChange(i)}
                                hasError={$errors.memberships[i]?.subscriber?.birthProvince}
                                containerStyles="box-shadow: 0px 1px 4px 0px rgb(0 0 0 / 15%); border-radius: 0px; height: 2.75rem"
                            />

                            {#if $errors.memberships[i]?.subscriber?.birthPlace}
                                <div class="pl-3 text-red-500">{$errors.memberships[i]?.subscriber?.birthPlace}</div>
                            {/if}
                        </div>
                    </div>
                </div>

                <!-- Data di nascita -->
                <div>
                    <div class="text-lg">Data di nascita</div>
                    <div class="w-full bg-white flex items-center">
                        <DateSearcher
                            bind:value={$form.memberships[i].subscriber.birthDate}
                            errorText={$errors.memberships[i]?.subscriber?.birthDate}
                            handleChange={(e) => {
                                handleBirthDateChange(i);
                                handleChange(e)
                            }}
                            name={`memberships[${i}].subscriber.birthDate`}
                            placeholder="Inserisci la data di nascita"
                            maxDateString={subscriberMaxBirthDate}
                        />
                    </div>
                </div>

                 <!-- Genere -->
                <div>
                    <div class="text-lg">Genere</div>

                    <RadioButtons
                        name={`memberships[${i}].subscriber.gender`}
                        isNullable={false}
                        options={genderOptions(i)}
                        handleChange={e => handleGenderChange(e, i)}
                        bind:inputValue={$form.memberships[i].subscriber.gender}
                    />
                </div>

                <div>
                    <div class="text-lg">Codice Fiscale</div>

                    <div class="flex flex-col md:flex-row gap-3">
                        <InputField
                            placeholder="Codice fiscale dell'iscritto"
                            bind:value={$form.memberships[i].subscriber.fiscalCode}
                            errorText={$errors.memberships[i]?.subscriber?.fiscalCode}
                            handleChange={handleChange}
                            name={`memberships[${i}].subscriber.fiscalCode`}
                            containerClass="w-full"
                            isRequired={true}
                        />

                        <button
                            class="w-full md:w-auto bg-blueGray-50 font-bold shadow-sm outline-none focus:outline-none px-6 disabled:opacity-30 h-11"
                            disabled={isFiscalCodeGeneratorDisabled($form.memberships[i])}
                            on:click|preventDefault={() => { handleGenerateFiscalCode(i)}}
                        >
                            GENERA
                        </button>


                        <!--{#if isFiscalCodeInverseGeneratorVisible($form.memberships[i])}-->
                        <!--    <button-->
                        <!--        class="w-full md:w-auto bg-blueGray-50 font-bold shadow-lg px-6 outline-none disabled:opacity-30 h-11"-->
                        <!--        on:click|preventDefault={() => invertFiscalCode($form.memberships[i].subscriber.fiscalCode, i)}-->
                        <!--    >-->
                        <!--        INVERTI-->
                        <!--    </button>-->
                        <!--{/if}-->

                    </div>
                </div>

                <!-- Nazionalità -->
                <div>
                    <div class="text-lg">Nazionalità</div>
                    <div class="w-full h-11">
                        <CountrySearcher
                            handleChange={() => handleChange}
                            required={true}
                            placeholder="Nazionalità"
                            name={`memberships[${i}].subscriber.nationality`}
                            bind:value={$form.memberships[i].subscriber.nationality}
                        />
                    </div>
                </div>

                <div>
                    <div class="block text-lg">Residenza</div>
                    <div class="w-full flex flex-col gap-2">
                        <CountrySearcher
                            handleChange={(value) => {
                                handleChange(value);
                                handleStateValue(value, i);
                            }}
                            required={true}
                            placeholder="Stato"
                            name={`memberships[${i}].subscriber.residenceAddress.country`}
                            bind:value={$form.memberships[i].subscriber.residenceAddress.country}
                        />

                         <!-- Città e cap -->
                        <div class="w-full flex flex-col gap-3 md:flex-row">
                            <div class="w-full md:w-8/12">
                                {#if $form.memberships[i]?.isItaly === true}
                                    <CitySearcher
                                        bind:value={$form.memberships[i].subscriber.residenceAddress.city}
                                        error={$errors.memberships[i]?.subscriber?.residenceAddress?.city}
                                        handleChange={(value) => {
                                            handleChangeCity(value, i);
                                        }}
                                        required={false}
                                    />
                                {:else}
                                    <InputField
                                        hasLabel={false}
                                        placeholder="Nome della città"
                                        errorText={$errors.memberships[i]?.subscriber?.residenceAddress?.city}
                                        name={`memberships[${i}].subscriber.residenceAddress.city`}
                                        handleChange={handleChange}
                                        isRequired={false}
                                    />
                                {/if}
                            </div>

                            <div class="w-full md:w-4/12">
                                {#if $form.memberships[i].isItaly}
                                    <CapSearcher
                                        placeholder={$form.memberships[i].isItaly ? "Scegli il tuo CAP" : "Scegli il tuo ZIP"}
                                        bind:value={$form.memberships[i].subscriber.residenceAddress.zip}
                                        error={$errors.memberships[i]?.subscriber?.residenceAddress?.zip}
                                        handleChange={handleChange}
                                        required={false}
                                        bind:zips={$form.memberships[i].zips}
                                    />
                                {:else }
                                    <InputField
                                        hasLabel={false}
                                        placeholder="Zip"
                                        bind:value={$form.memberships[i].subscriber.residenceAddress.zip}
                                        errorText={$errors.memberships[i]?.subscriber?.residenceAddress?.zip}
                                        name={`memberships[${i}].subscriber.residenceAddress.zip`}
                                        handleChange={handleChange}
                                        isRequired={true}
                                    />
                                {/if}
                            </div>
                        </div>

                        <!-- Indirizzo e numero civico -->
                        <div class="w-full flex flex-col gap-3 md:flex-row">
                            <div class="w-full md:w-8/12">
                                <InputField
                                    hasLabel={false}
                                    placeholder="Indirizzo"
                                    bind:value={$form.memberships[i].subscriber.residenceAddress.street}
                                    errorText={$errors.memberships[i]?.subscriber?.residenceAddress?.street}
                                    name={`memberships[${i}].subscriber.residenceAddress.street`}
                                    handleChange={handleChange}
                                    isRequired={true}
                                />
                            </div>
                            <div class="w-full md:w-4/12">
                                <InputField
                                    hasLabel={false}
                                    placeholder="Numero civico"
                                    bind:value={$form.memberships[i].subscriber.residenceAddress.number}
                                    errorText={$errors.memberships[i]?.subscriber?.residenceAddress?.number}
                                    name={`memberships[${i}].subscriber.residenceAddress.number`}
                                    handleChange={handleChange}
                                    isRequired={true}
                                />
                            </div>
                        </div>

                        <!-- Indirizzo secondario -->
                        <InputField
                            hasLabel={false}
                            placeholder="Scala / Palazzo / Settore"
                            bind:value={$form.memberships[i].subscriber.residenceAddress.secondary}
                            isRequired={false}
                        />
                    </div>
                </div>

                <!-- Email -->
                <div>
                    <div class="text-lg">Indirizzo e-mail</div>
                    <InputField
                        hasLabel={false}
                        placeholder="E-mail"
                        type="email"
                        bind:value={$form.memberships[i].subscriber.email}
                        errorText={$errors.memberships[i]?.subscriber?.email}
                        name={`memberships[${i}].subscriber.email`}
                        handleChange={handleChange}
                        isRequired={true}
                    />
                </div>

                <!--  Numero di telefono  -->
                <div>
                    <div class="text-lg">Numero di telefono</div>

                        <div class="w-full flex gap-3">
                        <div class="w-4/12 h-11">
                            <PrefixSearcher
                                bind:value={$form.memberships[i].subscriber.phone.code}
                                handleChange={() => handleChange}
                                required={true}
                            />
                        </div>

                        <input
                            placeholder="Numero di telefono"
                            name={`memberships[${i}].subscriber.phone.number`}
                            type="tel"
                            class="w-8/12 h-11 input-home"
                            class:border-error={$errors.memberships[i]?.subscriber?.phone?.number}
                            use:imask={ phoneMask }
                            id="phone.number"
                            maxlength="15"
                            required
                            on:change={handleChange}
                            bind:value={$form.memberships[i].subscriber.phone.number}
                        />

                    </div>

                    {#if $errors.memberships[i]?.subscriber?.phone?.number}
                        <div class="pl-3 text-red-500">
                            {$errors.memberships[i]?.subscriber?.phone?.number ?? ''}
                        </div>
                    {/if}
                </div>

                <div>
                    <div class="text-lg">
                        Professione
                    </div>

                    <select
                        bind:value={$form.memberships[i].subscriber.profession}
                        class="w-full input-home outline-none h-11 focus:outline-none"
                        name={`memberships[${i}].subscriber.profession`}
                        on:change={handleChange}
                        class:border-error={$errors.memberships[i]?.subscriber?.profession}
                    >
                        <option selected disabled class="text-gray-500">Seleziona una professione</option>
                        {#each mappedProfessions as profession}
                            <option value={profession.value}>{profession.label}</option>
                        {/each}
                    </select>


                    {#if $errors.memberships[i]?.subscriber?.profession}
                        <div class="pl-3 text-red-500">{$errors.memberships[i]?.subscriber?.profession}</div>
                    {/if}
                </div>

                <!-- Circolo -->
                <div>
                    <div class="text-lg">Circolo</div>
                    <div class="h-11 w-full">
                        <GroupNameSearcher
                            bind:value={$form.memberships[i].groupId}
                            municipalityId={$form.memberships[i].subscriber.residenceAddress.city?.value?.id}
                            handleChange={() => handleChange}
                        />
                    </div>
                </div>

                {#if isUGSActive(i)}
                    <div class="w-full">
                        <div class="text-lg">
                            Partecipazione a UGS
                        </div>

                        <RadioButtons
                            name={`memberships[${i}].subscriber.isUGS`}
                            options={ugsOptions(i)}
                            isNullable={false}
                            handleChange={handleChange}
                            bind:inputValue={$form.memberships[i].subscriber.isUGS}
                            errorText={$errors.memberships[i]?.subscriber?.isUGS}
                        />
                    </div>
                {/if}

                <!-- Quota -->
                <div>
                    <div class="text-lg">Quota</div>

                    <div class="relative">
                        <InputField
                            type="number"
                            placeholder="Somma pagata"
                            bind:value={$form.memberships[i].paidAmount}
                            errorText={$errors.memberships[i]?.paidAmount}
                            name={`memberships[${i}].paidAmount`}
                            min={0}
                            handleChange={handleChange}
                        />

                        <i class="absolute currency-icon font-450">€</i>
                    </div>
                </div>
            </div>

        </Accordion>
    {/each}

    <div class="flex flex-col w-full md:w-6/12 gap-3">
        <div class="flex w-full gap-3 flex-col md:flex-row">
            <button type="button" class="w-full md:w-6/12 bg-blueGray-600 font-450 py-3 text-white hover:shadow-lg transition-all outline-none focus:outline-none" on:click={addSubscriber}>
                Aggiungi <i class="ml-2 fa fa-plus"></i>
            </button>
            <button type="button" class="w-full md:w-6/12 bg-red-500 font-450 py-3 text-white hover:shadow-lg transition-all outline-none focus:outline-none" on:click={handleReset}>
                Cancella tutti i campi <i class="ml-2 fa fa-minus"></i>
            </button>
        </div>

        <button disabled="{isPressed}" type="button" class="w-full bg-lightBlue-500 font-450 py-3 text-white hover:shadow-lg transition-all outline-none focus:outline-none" on:click={handleSubmit}>
            Conferma <i class="ml-2 fa fa-check"></i>
        </button>
    </div>
</form>

<style>
    .currency-icon {
        top: 0.7rem;
        right: 3rem;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type=number] {
        -moz-appearance: textfield;
    }
</style>